var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.001,
    height: 74.999,
    viewBox: "0 0 75.001 74.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07c87a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "step3",
    transform: "translate(-4 -4.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M-12155.5-10709.413a37.259,37.259,0,0,1-14.595-2.947,37.414,37.414,0,0,1-11.921-8.038,37.4,37.4,0,0,1-8.037-11.921,37.241,37.241,0,0,1-2.947-14.595,37.241,37.241,0,0,1,2.947-14.595,37.38,37.38,0,0,1,8.037-11.92,37.4,37.4,0,0,1,11.921-8.036,37.241,37.241,0,0,1,14.595-2.947,37.242,37.242,0,0,1,14.6,2.947,37.4,37.4,0,0,1,11.921,8.036,37.38,37.38,0,0,1,8.037,11.92,37.241,37.241,0,0,1,2.947,14.595,37.241,37.241,0,0,1-2.947,14.595,37.4,37.4,0,0,1-8.037,11.921,37.414,37.414,0,0,1-11.921,8.038A37.26,37.26,0,0,1-12155.5-10709.413Zm-11.483-30.867a8.273,8.273,0,0,0,1.261,4.508,8.447,8.447,0,0,0,3.7,3.094,12.657,12.657,0,0,0,5.291,1.116,12.283,12.283,0,0,0,7.864-2.4,7.838,7.838,0,0,0,2.992-6.4,7.1,7.1,0,0,0-1.318-4.34,7.828,7.828,0,0,0-3.629-2.606,8.263,8.263,0,0,0,3.335-2.782,6.394,6.394,0,0,0,1.153-3.642,7.669,7.669,0,0,0-2.772-6.254,11.72,11.72,0,0,0-7.625-2.28,11.867,11.867,0,0,0-4.976,1.034,8.551,8.551,0,0,0-3.547,2.88,7.288,7.288,0,0,0-1.272,4.2h6.723a2.435,2.435,0,0,1,.988-1.985,3.606,3.606,0,0,1,2.325-.8,3.378,3.378,0,0,1,2.534.936,3.339,3.339,0,0,1,.9,2.405,3.9,3.9,0,0,1-.944,2.85,3.854,3.854,0,0,1-2.828.945H-12160v5.15h3.277a4.518,4.518,0,0,1,3.026.942,4.045,4.045,0,0,1,1.1,3.2,3.458,3.458,0,0,1-1.059,2.595,3.955,3.955,0,0,1-2.834,1.01,3.762,3.762,0,0,1-2.655-1,3.147,3.147,0,0,1-1.077-2.378Z",
    transform: "translate(12197 10788.413)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.22fbc4d9e117b3ba391058e79082def8.svg";
export { ForwardRef as ReactComponent };